/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXyVIcon32Regular = forwardRef('DataChartBarsXyVIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M4 4a1 1 0 0 1 1 1v18.5A2.5 2.5 0 0 0 7.5 26H28a1 1 0 1 1 0 2H7.5A4.5 4.5 0 0 1 3 23.5V5a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M10 15.286a1 1 0 0 1 1 1V21a1 1 0 1 1-2 0v-4.714a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M16 9.429a1 1 0 1 0-2 0V21a1 1 0 0 0 2 0V9.429Z" }),
        React.createElement("path", { d: "M25 5a1 1 0 0 1 1 1v15a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M21 12.857a1 1 0 1 0-2 0V21a1 1 0 1 0 2 0v-8.143Z" })));
});
